import { Timeline } from "antd";
import { Card } from "@rumbledirect/ui";

interface ClaimDossierOverviewTimelineCardProps {
  isLoading: boolean;
}

export const ClaimDossierRepairTimelineCard = ({
  isLoading,
}: ClaimDossierOverviewTimelineCardProps) => {
  const timelineItems = [
    {
      color: "grey",
      children: "Afspraak ingepland",
    },
    {
      color: "grey",
      children: "Voertuig bij hersteller",
    },
    {
      color: "grey",
      children: "Reparatie gestart",
    },
    {
      color: "grey",
      children: "Reparatie voltooid",
    },
    {
      color: "grey",
      children: "Voertuig opgehaald",
    },
  ];

  return (
    <Card loading={isLoading} className="w-full mt-5" title="Status reparatie">
      <Timeline style={{ marginBottom: -25 }} items={timelineItems} />
    </Card>
  );
};
